import React from "react";
import { cn } from "../../../common/u1/cn";
import { completionTone, completionWidth } from "./enterpriseRows";

/* How complete a tracked business's profile is. */
const TONES = {
  low: "bg-[var(--coral)]",
  mid: "bg-[var(--warning)]",
  high: "bg-[var(--success)]",
};

/* Two widths of the same meter. */
const SIZES = {
  /* `w-full` belongs to the table's column, which has a width to fill. */
  md: { track: "w-full min-w-[80px] max-w-[130px]", gap: "gap-3", figure: "w-[40px]" },
  /* A SHORTER track, not a collapsible one. */
  /* A FIXED width, with no `w-full`. */
  sm: { track: "w-[80px]", gap: "gap-2", figure: "w-auto" },
};

export const ProfileCompletionBar = ({ percent, size = "md", className = "" }) => {
  const width = completionWidth(percent);
  const tone = TONES[completionTone(percent)];
  /* Printed as the API sent it, even where the bar had to clamp. */
  const shown = Number(percent) || 0;
  const variant = SIZES[size] || SIZES.md;

  return (
    <span className={cn("flex min-w-0 items-center", variant.gap, className)}>
      <span
        role="meter"
        aria-valuenow={shown}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Profile completion"
        className={cn(
          "h-[7px] shrink-0 overflow-hidden rounded-full bg-[var(--slate-3)]",
          variant.track
        )}
      >
        <span
          aria-hidden="true"
          className={cn("block h-full rounded-full transition-[width]", tone)}
          style={{ width: `${width}%` }}
        />
      </span>
      {/* Never the part that gives way: a clipped percentage is worse than a
          shorter bar. */}
      <span
        className={cn(
          "shrink-0 whitespace-nowrap text-right text-[13px] font-semibold",
          "text-[var(--ink)] font-sans tabular-nums",
          variant.figure
        )}
      >
        {shown}%
      </span>
    </span>
  );
};

export default ProfileCompletionBar;
